import Repository from './Repository'

const licenses = 'license'

export default {
    // Fetch Licenses
    fetchLicenses() {
        return Repository.get(`${licenses}`)
    },
}